<template>
  <div class="content-right" style="margin-top: 0px">
    <a-spin :spinning="detailSpinning">
      <detail-list :article="article" :reviewInfo="reviewInfo" @submitSuccess="getDetailInfo" />
    </a-spin>
  </div>
</template>

<script>
import DetailList from '../documentDetail/components/DetailList'
export default {
  data() {
    return {
      article: {},
      detailSpinning: true,
      reviewInfo: {}
    }
  },
  components: {
    DetailList
  },
  methods: {
    async getDetailInfo() {
      this.detailSpinning = true;
      try {
        const res = await this.axios.get(`/biz/home/document/detail`, {
          params: { id: this.$route.params.id }
        });
        if (res.success) {
          const res2 = await this.axios.get(
            "/biz/home/document/stuBackDocDetail",
            { params: { id: this.$route.params.id } }
          );
          if (res2.success) {
            this.reviewInfo = res2.result || {};
            res.result.visibles = JSON.parse(res.result.visibles || "[]");
            res.result.visibles.forEach(item => {
              item.value = this.reviewInfo[item.label] || undefined;
            });
            res.result.configList.forEach(item => {
              item.fileList = (this.reviewInfo.docList || []).filter(
                ite => ite.configId === item.id
              );
            });
          }
          this.article = res.result;
        }
      } finally {
        this.detailSpinning = false;
      }
    }
  },
  mounted() {
    this.getDetailInfo();
  }
};
</script>

<style lang="scss" scoped>
.content-right {
  padding: 24px;
}
</style>



// WEBPACK FOOTER //
// src/pages/documentItem/index.vue